import blue from 'material-ui/colors/blue'
import { createMuiTheme } from 'material-ui/styles'
import { light } from 'material-ui/styles/createPalette'
import createTypography from 'material-ui/styles/createTypography'

let clintal_blue = 'rgb(65, 139, 181)'

const theme = createMuiTheme({
  palette: {
    primary: {
      ...blue,
      500: clintal_blue,
    },
  },
  typography: createTypography(light, { htmlFontSize: 10 }),
})

export default theme
